import { CounselingTypeEnum } from 'app/Bookings/constants'
import {
  counselingTypeIconMap,
  counselingTypeDisplayLabelMap,
  counselingTypeDescriptionMap,
} from '../constants'

type CounselingTypeCardContentProps = {
  counselingType: CounselingTypeEnum
  fallbackLabel: string
  variant: 'desktop' | 'mobile'
}

const variantStyles = {
  desktop: {
    iconSize: 32,
    title: '~text-black ~font-gibson ~text-base ~font-medium',
    description: '~text-black ~font-gibson ~text-sm ~font-normal',
  },
  mobile: {
    iconSize: 24,
    title: '~text-black ~font-gibson ~text-sm ~font-medium',
    description: '~text-charcoal ~font-gibson ~text-xs ~font-normal',
  },
}

const CounselingTypeCardContent: React.FC<CounselingTypeCardContentProps> = ({
  counselingType,
  fallbackLabel,
  variant,
}) => {
  const iconSrc = counselingTypeIconMap[counselingType]
  const displayLabel =
    counselingTypeDisplayLabelMap[counselingType] ?? fallbackLabel
  const description = counselingTypeDescriptionMap[counselingType]
  const styles = variantStyles[variant]

  return (
    <div className="~flex ~flex-col ~items-start ~text-left">
      {iconSrc && (
        <img
          src={iconSrc}
          width={styles.iconSize}
          height={styles.iconSize}
          alt=""
        />
      )}
      <span className={`~mt-4 ${styles.title}`}>{displayLabel}</span>
      {description && <span className={styles.description}>{description}</span>}
    </div>
  )
}

export default CounselingTypeCardContent
